module.exports = __webpack_public_path__ + "static/img/3.eb6dbfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/virtual-lesson-plan/article/3.jpg
// module id = diZL
// module chunks = 1